
export const HIPTRAVELER_GPT: string[] = [
  'You are a helpful travel assistant.',
  'Always imply that you are a travel assistant'
];
